<template>
  <div class="bg-container page">
    <img class="bg-img" src="img/login/login-bg.png">
    <div class="bg-wrapper">
      <div class="login">
        <van-nav-bar class="nav-bar">
          <template #left>
            <van-icon color="#fff" name="arrow-left" @click="$router.back()"/>
          </template>
          <template #right>
            <Language/>
          </template>
        </van-nav-bar>
        <div class="wrapper">
          <div class="logo-container">
            <div class="logo-wrapper">
              <img
                  :src="this.$store.getters.getBaseInfo.ico !==undefined ?this.$store.getters.getBaseInfo.ico:'/img/null.png'"
                  class="logo-img" alt="">
            </div>
          </div>
          <div class="platform-name">{{this.$store.getters.getBaseInfo.name}}</div>
          <div class="title">{{ $t('登录') }}</div>
          <div class="loginForm">
            <van-field v-model="username" class="input" clearable input-align="center" :placeholder="$t('请输入用户名')"/>
            <van-field
                v-model="password"
                :type="passwordType"
                class="input"
                input-align="center"
                :placeholder="$t('请输入密码')"
            >
              <template slot="right-icon" v-if="isEye">
                <van-icon :name=" passwordType === 'password' ? 'closed-eye':'eye-o'" @click="switchPasswordType"/>
              </template>
            </van-field>
            <div class="reset-text">
              <span>{{ $t('忘记密码') }}？</span>
            </div>
            <div class="register-text" @click="toRegister()">
              <span>{{ $t('没有账户？马上注册') }}</span>
            </div>
            <van-button class="login-btn" size="normal" type="primary" @click="doLogin()">{{ $t('登录') }}</van-button>
          </div>
        </div>
      </div>
    </div>
    <LanguagePopup v-model="languagePopupVisible"/>
  </div>
</template>

<script>
import Language from "@/components/Language.vue";
import LanguagePopup from "@/components/LanguagePopup.vue";

let Base64 = require('js-base64').Base64;

export default {
  components: {Language, LanguagePopup},
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      username: '',
      password: this.inputValue,
      passwordType: 'password',
      languagePopupVisible: false,
      isEye:true
    };
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back() {
      return window.history.back();
    },
    toRegister() {
      this.$router.push("Register")
    },
    doLogin() {
      if (this.username === "" || this.username === null || this.username === undefined) {
        this.$toast(this.$t("请输入用户名"+ '！'));
        return false;
      }
      if (this.password === "" || this.password === null || this.password === undefined) {
        this.$toast(this.$t("请输入密码"+ '！'));
        return false;
      }
      let reqData = {username: this.username, password: this.password}
      if (this.token) {
        //被踢下线时记住token
        Object.assign(reqData,{...reqData,off_token:this.token})
      }
      this.$http({
        method: 'get',
        data: reqData,
        url: 'member_login'
      }).then(res => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem('token', res.data.id)
          // 清除所缓存的账号
          if (localStorage.getItem('logData')) localStorage.removeItem('logData')
          this.$router.push("Mine")
        } else {
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if (localStorage.getItem('token')) {
      return window.history.back();
    }
    // 隐藏登录页语言选择弹窗
    // if (localStorage.getItem('firstLoad') !== 'false') {
    //   this.languagePopupVisible = true;
    // }
    // 判断是否是踢下线，所缓存的账户密码
    if (localStorage.getItem('logData')) {
      let {username,off_token} = JSON.parse(Base64.decode(localStorage.getItem('logData')))
      this.username = username
      this.password = off_token.substring(0,9)//仅用于展示
      this.token = off_token
      this.isEye = false //密码不可看
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.login {
  height: 100%;
}

.bg-container .bg-wrapper .login .nav-bar {
  background: 0 0
}

.login .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.logo-container {
  margin: 0 auto;
  width: 45%;
}

.logo-container .logo-wrapper {
  position: relative;
  padding-bottom: 62.5%;
}

.logo-container .logo-wrapper .logo-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}

.login .wrapper .title {
  line-height: 100px;
  text-align: center;
  font-size: 45px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 5px;
}

.login .wrapper .loginForm {
  padding: 10px 60px 60px 60px;
}

.login .wrapper .loginForm .input {
  padding: 10px 20px;
  margin-top: 40px;
  border-radius: 50px;
  text-align: center;
  line-height: 80px;
  font-size: 30px;
  color: #4e4e4e;
}

::v-deep .van-field__right-icon .van-icon {
  font-size: 50px;
}

::v-deep .van-icon {
  font-size: 50px;
}

.login .wrapper .loginForm .reset-text {
  margin: 30px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.login .wrapper .loginForm .reset-text span {
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 15px;
}

.login .wrapper .loginForm .register-text {
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login .wrapper .loginForm .register-text span {
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 20px;
}

.login .wrapper .loginForm .active {

}

.login .wrapper .loginForm .login-btn {
  margin-top: 85px;
  width: 100%;
  height: 100px;
  border-radius: 50px;
  color: #fff;
  background-color: #7e5678;
  font-size: 30px;
  font-weight: bolder;
  border: none;
}
.platform-name {
  font-size: 44px;
  font-style: italic;
  font-weight: bold;
  text-align: center;
  margin-top: 10px;
}

// PC端适配：重置vw为px值，并适配430px宽度 (比例: 430/750 = 0.5733)
@media (min-width: 768px) {
  .login {
    .logo-wrapper {
      padding-bottom: 116px;
    }
    .platform-name {
      margin-top: 6px;
      font-size: 24px;
    }
    > .wrapper {
        .loginForm {
          padding: 6px 33px 33px;
          .input {
            padding: 6px 12px;
            margin-top: 22px;
            border-radius: 32px;
            line-height: 44px;
            font-size: 16px;
            ::v-deep .van-field__right-icon .van-icon {
              font-size: 32px;
            }

            ::v-deep .van-icon {
              font-size: 32px;
            }
          }
          .reset-text {
            margin: 16px 8px;
            cursor: pointer;
          }
          .register-text {
            margin: 5px 0;
            cursor: pointer;
          }
          .reset-text span,.register-text span {
              font-size: 14px;
              line-height: 9px;
            }
          .login-btn {
            margin-top: 47px;
            height: 55px;
            border-radius: 35px;
            font-size: 16px;
          }
        }

        > .title {
          line-height: 55px;
          font-size: 25px;
        }
      }
  }
  
  // 导航栏PC端适配
  ::v-deep .nav-bar {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }
  
  ::v-deep .van-nav-bar {
    height: 57px !important;
    line-height: 57px !important;
  }
  
  ::v-deep .van-nav-bar__content {
    height: 57px !important;
  }
  
  ::v-deep .van-nav-bar__title {
    font-size: 20px !important; /* 35px * 0.5733 ≈ 20px */
  }
  
  ::v-deep .van-nav-bar .van-icon {
    font-size: 26px !important; /* 45px * 0.5733 ≈ 26px */
  }
}

</style>
